import io from "socket.io-client";
import { newPop } from '@/utils/popup.js';
export const socketio ={
    data() {
        return{ 
          messages: [],
          users: [],//해당방 접속 유저
          online_users:'',//접속자 전체
          admin_messages: [],
          currentUser: "",
          userIP: "",
          Mtm:false,
          mtmRoomId:'',
          mtmUserId:'', 
          mtmUserNic:'', 
          mtmInfo:'',
          socket: io(this.$store.state.serverDomain + ":3000"),  
          newChatRoom:false,
          mtm_join:''   //값이 들어오면 1:1 채팅 수락한것이다      
        }
    },
    mounted() {
        this.joinServer();
    },
    computed:{
      isSound(){
        return this.$store.state.sets.chatsound;
      }, 
      currentMode(){
        return this.$store.state.sets.mode;
      }    
    },
    // watch: {
    //   isGoodsNew:function(curValue, oldValue) {
    //     if (curValue && curValue !== oldValue) {
    //       this.newGoodsState();
    //     }
    //   }
    // },
    methods: {
        mtmpopClose(result){
          if(result ==='join')
          {
            this.socket.emit("MtmJoin", this.mtmInfo, function (callback) {
              console.log(callback);
            });
          }else{
            this.socket.emit("MtmDeny", this.mtmInfo, function (callback) {
              console.log(callback);
            });
          }
           
            this.Mtm=false;
        },
        playSound(filename) {
          if(this.isSound){
            let audio = new Audio(`${require('@/assets/sound/'+filename+'.wav')}`);
            audio.play();
          }         
        },
        joinServer() {
            this.socket.on("connect", () => {
              console.log("연결", this.currentUser);
              let thisuser = this.currentUser;
              let params = {};
              if (this.isLoggedIn) {
                params = {
                  room: this.chat_roomId,
                  nic: thisuser.nic,
                  level: thisuser.level,
                  userId: thisuser.id,
                  profile_photo_path:thisuser.profile_photo_path,
                  profile_photo_url:thisuser.profile_photo_url,
                  ip: this.userIP,
                  role:thisuser.role
                };
              } 
              else {
                params = {
                  room: this.chat_roomId,
                  nic: thisuser.nic,
                  level: 0,
                  userId: 0,
                  profile_photo_url: "",
                  ip: this.userIP,
                  role:"guest"
                };
              }
              this.socket.emit("join", params, function (err) {
                if (err) {
                  alert("에러");
                } else {
                  console.log("No Error");
                }
              });
            });
            // this.socket.on('loggedIn', data=>{
            //     this.messages = data.messages;
            //     this.users = data.users;
            //     this.socket.emit('newuser', this.username);
            // })
            this.listen();
        },
        listen() {
            // this.socket.on('userOnline', user=>{
            //     this.users.push(user);
            // })
            // this.socket.on('userLeft', user=>{
            //     this.users.splice(this.users.indexOf(user), 1)
            // })
            this.socket.on("newJoin", (newjoin) => {
              console.log("새로운 접속",newjoin);
              if (newjoin && newjoin.room !== this.chat_roomId && newjoin.nic === this.currentUser.nic) {
                //alert('다른곳에서 접속')
                //this.otherConnect = true;
                this.messages.push({from:'Admin', text:'다른곳에서 접속하셨습니다.', color:'red'});
                this.isChat = false;
                //this.socket.disconnect();
              }

              //위젯 제외
              const widgets = ["widget",'widget_counter'];
              let widget = widgets.includes(this.$route.name);
              //alert(this.$route.name);
              if(newjoin.room !=='m1' && !widget)
              {
                this.playSound('room_enter');
              }
              
              //console.log('새로운 접속 socket.id',user.socketid);
            });
            this.socket.on("newMessage", (message) => {
              //console.log("새로운 메세지", message);
              
              this.messages.push(message);
              // if(message.room !== 'm1')
              // {
                //console.log("새로운 메세지", message.room);
                this.playSound('new_message');
              //}
              
              // if (message.from === "Admin") {
              //   this.admin_messages.push(message);
              // } else {
              //   this.messages.push(message);
              // }
              console.log("소켓ID", this.socket.id);
            });

            this.socket.on("UpdateRoom", (room_id) => {    
                     
              if(this.chat_roomId === 'room_'+room_id)
              {
                //alert('룸 업데이트 발생');
                this.$store.state.chat.updateroom =  room_id;
              }            
            });
            // this.socket.on('msg', message=>{
            //     this.messages.push(message);
            // })
            this.socket.on("updateUsersList", (users) => {
              this.users = users;
              //console.log('챗베이스에서 유저 체크',this.users)
              this.$emit('update-userlist', this.users);
              
              //접속 유저 업데이트
              this.$store.commit('users/setConnetcionUsers',this.users);
            });
            this.socket.on("updateConnectionUsers", (param) => {
              
              console.log('접속 유저 업데이트', param)
              this.online_users = param.online_users;              
              //접속 유저 업데이트
              //this.$store.dispatch('users/updateOnlineUsers',param);
            });
            this.socket.on("updateMessagesList", (messages) => {
              this.messages = messages;
              console.log(this.messages);
            });
            this.socket.on("reqMtm", (params) => {
              if (params && params.tosocketid === this.socket.id) {
                      //alert('1:1채팅 신청');
                      //alert(params.fromId);

                this.Mtm=true;
                this.mtmInfo = params;
                this.mtmRoomId=params.room;
                this.mtmUserId =params.fromId;
                this.mtmUserNic =params.fromNic;
              }
                  //console.log('새로운 접속 socket.id',user.socketid);
            });

            this.socket.on("MtmDeny", (params) => {
              this.messages.push({from:'Admin', text:params.toNic +' 님이 1:1 채팅을 거절했습니다.', color:'red'});
              //console.log('새로운 접속 socket.id',user.socketid);
            });

            this.socket.on("MtmJoin", (params) => {
              this.messages.push({from:'Admin', text:params.toNic +' 님이 1:1 채팅에 입장하셨습니다.', color:'blue'});
              //console.log('새로운 접속 socket.id',user.socketid);
            });

            //채팅내용 삭제
            this.socket.on("ChatClear", (params) => {
              if(this.chat_roomId === params.room_id)
              {
                //alert('룸 업데이트 발생');                
                if(this.messages.length >0){
                  this.messages =[]; 
                  this.messages.push({from:'Admin', text:params.who + ' 에 의해 화면이 초기화 되었습니다.', color:'red'});       
                }   
              }                
              //console.log('새로운 접속 socket.id',user.socketid);
            });

            this.socket.on("receiveMessage", async(receive) => {
              //console.log("쪽지가 발송 됨",receive);
              if(receive.toNic === this.currentUser.nic)
              {
                  try {
                      const response = await this.$store.dispatch('message/getMessageCount',{user_id:this.currentUser.id});//새쪽지
                       console.log(response);
                       this.$flashMessage.show({
                          type: "info",
                          title: "새로운 쪽지를 받았습니다.",
                          message: '새로운 쪽지를 받았습니다.',
                      });
                      this.playSound('new_message');
                      opener.location.reload()
                  }catch(e)
                  {
                      console.log(e);
                  }
              }
              //console.log('새로운 접속 socket.id',user.socketid);
            });

          //새로운 채팅방 생성  
          this.socket.on("NewChatRoom", () => {
            //alert('채팅방 신규 생성');
            this.newChatRoom = true;
          });
        },
        sendMessage(message) {
            
            let params = { nic: this.currentUser.nic, text: message, room: this.chat_roomId};
            this.socket.emit("createMessage", params, function (message) {
              console.log("서버응답:", message);
            });
        },
        joinmtm()
        {
          alert('1:1채팅 참여');
          //this.socket.disconnect();
          //참여 하면서 1:1 채팅 신청자의 아이템 차감
          this.$store.dispatch('item/deductionItem',
                  {user_id:this.mtmUserId, item_name:'chat_mtm'});//1:1채팅 신청자 아이템 차감
          this.playSound('room_enter');
          //this.$router.push({path: "mtm/mtm_01"});
          //팝업으로 오픈
          if(this.currentMode ==='PC')
          {
            const url="/chat/mtm/"+this.mtmRoomId
            newPop('mtm_'+this.mtmRoomId,url,'','',500,400);
          }else{
            //alert(this.mtmRoomId); 
            //모바일에서 접속
            this.$store.commit('sets/addMtmJoin',{room:this.mtmRoomId,nic:this.mtmUserNic});
            this.mtm_join = this.mtmRoomId;
          }         

          this.mtmpopClose('join')
        },
        disconnect()
        {
          //alert('호출');
          this.socket.disconnect();
        }
       
       
    },
}
